import {
  IConfiguration,
  IConfigurationService,
} from "../../domain/configuration";
import store from "../../store";
import { ObjectUtility } from "../../utilities";
import { SessionStorageAccessor } from "../../store/SessionStorageAccessor";
import { IConfigurationRepository } from "./IConfigurationRepository";
import { LoggerFactory } from "../../utilities/logger";

export class ConfigurationService<TConfiguration extends IConfiguration = IConfiguration> implements IConfigurationService<TConfiguration> {
  constructor(private readonly _repository: IConfigurationRepository<TConfiguration>) {
  }

  private readonly logger = LoggerFactory.getLogger();

  async load(): Promise<void> {
    const loaded = await this.loadConfiguration();
    const merged = ObjectUtility.mergeDeeply(
      this._repository.getDefaultConfiguration(),
      loaded);
    // this.logger.debug(JSON.stringify(merged));
    this.validateJapaneseEras(merged);
    store.commit("setConfiguration", merged);
  }

  getConfiguration(): TConfiguration {
    return store.getters.configuration as TConfiguration;
  }

  private async loadConfiguration(): Promise<TConfiguration> {
    if (store.getters.configuration) {
      this.logger.info("既にstoreに格納されてる設定を利用します.");
      return store.getters.configuration;
    } else if (SessionStorageAccessor.configuration) {
      this.logger.info("セッションストレージに格納されてる設定を利用します.");
      return SessionStorageAccessor.configuration as TConfiguration;
    } else {
      this.logger.info("バックエンドから設定を取得します.");
      return this._repository.getConfiguration();
    }
  }

  private validateJapaneseEras(configuration: TConfiguration): void {
    this.validateJapaneseEra(configuration, "令和");
    this.validateJapaneseEra(configuration, "平成");
    this.validateJapaneseEra(configuration, "昭和");
    this.validateJapaneseEra(configuration, "大正");
    this.validateJapaneseEra(configuration, "明治");
  }

  private validateJapaneseEra(configuration: TConfiguration, name: string): void {
    const japaneseEras = configuration.system.date.japaneseEras;
    if (!japaneseEras.find(era => era.name === name)) { throw new Error(name + "の和暦設定がありません."); }
  }
}
